import React from 'react';
import {
  Layout,
  Row,
  Col,
  message,
  Button,
} from 'antd';
import img from '../../assets/img/At the office-pana 1.png';
import TableWrapper from '../elements/TableWrapper';
import MiCompAPI from '../../util/api';
import moment from 'moment';
const { Content } = Layout;
class MemberEnquiry extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [{
      title: 'Enquiry No',
      dataIndex: 'enqId',
      sorter: (a, b) => a.enqId.localeCompare(b.enqId),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'LOA',
      dataIndex: 'loA',
      sorter: (a, b) => a.loA.localeCompare(b.loA),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Family Type',
      dataIndex: 'family',
      sorter: (a, b) => a.family.localeCompare(b.family),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: 'Enquiry Date',
      dataIndex: 'createdOn',
      sorter: (a, b) => new Date(a.createdOn) - new Date(b.createdOn),
      render: (text, record) =>
        record["createdOn"] !== null && record["createdOn"] !== ""
          ? moment(record["createdOn"]).format("MM/DD/YYYY")
          : "",
      sortDirections: ["descend", "ascend"]
    }, {
      title: 'Finalized Rate',
      dataIndex: 'finalized_rate',
      render: (text, record) => text && text !== "" && "$" + text

    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      sortDirections: ["descend", "ascend"]
    }];
    this.columns_Inner = [
      {
        title: 'Broker',
        dataIndex: 'broker',
        sorter: (a, b) => a.broker.localeCompare(b.broker),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Plan',
        dataIndex: 'plan',
        sorter: (a, b) => a.plan.localeCompare(b.plan),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Carrier',
        dataIndex: 'carrier',
        sorter: (a, b) => a.carrier.localeCompare(b.carrier),
        sortDirections: ["descend", "ascend"]
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        render: (text, record) => text && text !== "" && "$" + text

      },
      {
        title: 'Status',
        dataIndex: 'status',
        sorter: (a, b) => a.status.localeCompare(b.status),
        sortDirections: ["descend", "ascend"]
      }
      ,
      {
        title: 'Actions',
        dataIndex: '',
        render: (text, record) => {
          return (
            <div>
              {record.status === "InProgress" && <i onClick={() => this.FinalizeRate(record.id)} className="fa fa-check fa-blue" ></i>}
            </div>
          );
        },


      }
    ];
    this.state = {
      MemberEnquirys: [],
      isLoading:false,
    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount() {
    this.GetAllMemberEnquiries();
  }
  GetAllMemberEnquiries() {
    this.setState({
      isLoading: true
  })
    this.api.invoke("GetAllMemberEnquiries",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              MemberEnquirys: data.data,
              isLoading:false,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      });
  }
  FinalizeRate(id) {
    this.api.invoke("FinalizeRate/" + id,
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetAllMemberEnquiries();

            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      });
  }
  render() {
    return (
      <Content>
        <div className="mi_main_div">
          <div className="mi_box" style={{ marginTop: '20px',marginLeft:"10px",marginRight:"10px" }}>
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4">Enquiry</h4>
              </Col>
              <Col span={6}>
                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
              </Col>
            </Row>
          </div>
          <Row span={24} style={{ marginBottom: "-20px" ,marginLeft:"10px",marginRight:"10px" }}>
            <Col>
              <Button style={{ marginRight: "5px" }} className="ant-btn table-operation submit-button ant-btn-primary" onClick={() => { this.props.history.push("addenquiry"); }}>
                New Enquiry
              </Button>
            </Col>
          </Row>
          <div style={{marginLeft:"10px",marginRight:"10px" }}>
          <TableWrapper
            expandedRowRender={(record) => (
              <>
                <TableWrapper
                  rowKey="member_id"
                  data={record.itemsDTOs.map((x) => {
                    return {
                      ...x,
                      broker: x.broker,
                      carrier: x.carrier,
                      plan: x.plan,
                      enqId: x.enqId,
                    };
                  })}
                  columns={this.columns_Inner}
                  
                ></TableWrapper>
              </>
            )}
            rowKey="id"
            columns={this.columns}
            data={this.state.MemberEnquirys}
            title="Enquiries"
            buttons={this.tableButtons}
            search={true}
            loading={this.state.isLoading}
          />
          </div>
        </div>
      </Content>
    );
  }
}
export default MemberEnquiry;